module.exports = __webpack_public_path__ + "static/media/20170806_36day_1808AT.d2fe32dc.jpg";